import { ref, computed, watch, toRaw } from 'vue';
import { isEqual } from 'lodash';

export const useProgress = () => {
    const target = ref(0);
    const current = ref(0);

    const progress = computed(() => {
        return target.value ? (current.value / target.value) * 100 : 0;
    });

    const reset = () => {
        target.value = 0;
        current.value = 0;
    }

    return {
        target,
        progress,
        current,
        reset,
    }
};

export function useData() {
    if (typeof window === 'undefined') return {};
    return window.__VUE_APP_PAGE_CONTEXT__?.data || {};
}

export function usePageContext() {
    if (typeof window === 'undefined') return {};
    return window.__VUE_APP_PAGE_CONTEXT__?.pageContext || {};
}

export function useDirty (target) {
    const dirty = ref(false);
    const initialValue = toRaw(target);

    watch(target, (newValue) => {
        dirty.value = !isEqual(newValue, initialValue);
    });

    return {
        dirty,
    };
}